import http from '../http-common'

export const sendOtp = (email: string) => http.post('/validation/send', { email: `${email}` })
export const resendOtp = (email: string) => http.post('/validation/resend', { email: `${email}` })
export const validateOtp = (email: string, otp: string) => http.post('/validation/verify', { email, otp })
